// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2Tj4t","addWidgetButton":"Header_addWidgetButton__372xd","dashboardTabs":"Header_dashboardTabs__3itsV","active":"Header_active__1D9nW"};